import { FC, useContext, useEffect, useRef } from 'react'
import styles from '../../assets/scss/components/layout/notification-bar.module.scss'
import { HeaderContext } from '../header/header-provider.client'

export const NotificationBar: FC<{ message?: string }> = ({ message }) => {
  const ref = useRef<HTMLDivElement>(null)
  const { setNotificationBarBoundingClientRect } = useContext(HeaderContext)

  useEffect(() => {
    if (ref.current) {
      setNotificationBarBoundingClientRect(ref.current.getBoundingClientRect())
    }
  }, [ref])

  if (!message) {
    return null
  }

  return (
    <div className={styles.notificationBar} ref={ref}>
      {message}
    </div>
  )
}
